/**
 * Small deterministic PRNG (mulberry32) so generated shapes are reproducible
 * for a given seed.
 */

type Rng = () => number;

const createRng = (seed: number): Rng => {
    let a = seed >>> 0;
    return () => {
        a |= 0;
        a = (a + 0x6D2B79F5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t ^= t + Math.imul(t ^ (t >>> 7), 61 | t);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
};

// standard normal via Box-Muller
const createGaussianRng = (rng: Rng) => {
    let spare: number | null = null;
    return () => {
        if (spare !== null) {
            const value = spare;
            spare = null;
            return value;
        }
        let u, v, s;
        do {
            u = rng() * 2 - 1;
            v = rng() * 2 - 1;
            s = u * u + v * v;
        } while (s >= 1 || s === 0);
        const mul = Math.sqrt(-2 * Math.log(s) / s);
        spare = v * mul;
        return u * mul;
    };
};

export { Rng, createRng, createGaussianRng };
